import { render, staticRenderFns } from "./ru-RU.vue?vue&type=template&id=1deb7108&"
import script from "./ru-RU.vue?vue&type=script&lang=js&"
export * from "./ru-RU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1deb7108')) {
      api.createRecord('1deb7108', component.options)
    } else {
      api.reload('1deb7108', component.options)
    }
    module.hot.accept("./ru-RU.vue?vue&type=template&id=1deb7108&", function () {
      api.rerender('1deb7108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/ru-RU.vue"
export default component.exports